const EXPORT_FILENAME_TERM_MAP: Record<string, string> = {
    campaign: 'journey',
    campaigns: 'journeys',
}

export function normalizeExportFilename(value: string): string {
    return value.replace(/(^|[_-])(campaigns?)($|[_-])/g, (_, prefix, term, suffix) => {
        return `${prefix}${EXPORT_FILENAME_TERM_MAP[term] ?? term}${suffix}`
    })
}
